import Entity from '../../utilities/entity';

import TrainingSessionLesson from './session-lesson';

class TrainingSession extends Entity {

    // lessons() {
    //     return this.hasMany(TrainingSessionLesson);
    // }

}

export default new TrainingSession();